import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../mock/data";
import useReveal from "../hooks/useReveal";

function Stat({ item }) {
  const { ref, inView } = useReveal();
  const [display, setDisplay] = useState(item.value);
  const numeric = /^\d+$/.test(item.value);

  useEffect(() => {
    if (!inView || !numeric) return;
    const target = parseInt(item.value, 10);
    let cur = 0;
    const step = Math.max(1, Math.ceil(target / 40));
    const t = setInterval(() => {
      cur += step;
      if (cur >= target) {
        cur = target;
        clearInterval(t);
      }
      setDisplay(String(cur));
    }, 30);
    return () => clearInterval(t);
  }, [inView]);

  return (
    <div ref={ref} className={`reveal ${inView ? "in-view" : ""} text-center`}>
      <div className="font-display text-5xl md:text-7xl text-white leading-none">
        {display}
        <span className="baja-red">{item.suffix}</span>
      </div>
      <div className="mt-3 font-cond uppercase tracking-widest text-sm text-white/50">
        {item.label}
      </div>
    </div>
  );
}

export default function StatsSection() {
  return (
    <section className="bg-[#111] border-y border-white/10 py-16">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-10">
        {STATS.map((s) => (
          <Stat key={s.id} item={s} />
        ))}
      </div>
    </section>
  );
}
